import { Directive, HostListener } from '@angular/core';
import { GlobalClassInstance } from '@commoncore/constants/GlobalClass';
import { Controller } from '@commoncore/controller/Controller';
import { LocalStorageProps } from '@commoncore/enums/localStorageProps';
import { AllFilesImplementation } from '@commoncore/implementation/AllFilesImplementation';
import { FileOperationsImplementation } from '@commoncore/implementation/FileOperationsImplementation';
import { LocalStorageSvc } from '@commoncore/services/localStorage.service';
import { AppEvents } from '@commoncore/utils/app-events';
import { ENV_CONSTANTS } from '@env-properties/environment';
import { ENV_CONFIG } from '@env-properties/environment-config';
import { USER_DETAILS } from '../constants/Constants';

@Directive()
export class AllFilesController extends Controller{
    public allFilesImplementation:any;
    public fileOperationsImplementation:any;
    public universalService:any;
    public router:any;
    public http:any;
    public fetchFolderData:boolean=false;
    public static singleInstance:any = null
    public globalService: any;
    public homeController:any;
    public listService: any;
    public localStorageSvc: LocalStorageSvc;
    loggerService: any;
    containerHeightCalc:any;
    lazyLoadImgService:any;
    sessionStorageService:any;
  
    @HostListener('window:resize', [])resize(){
      var self = this;
      self.allFilesImplementation.setHeightForView();
    }
    public constructor(globalService) {
      super(globalService);
      this.allFilesImplementation= AllFilesImplementation.getInstance(globalService);	
      this.fileOperationsImplementation= FileOperationsImplementation.getInstance(globalService);
    }
    
    public static getInstance(globalService):AllFilesController{
		if(this.singleInstance == null){
			this.singleInstance = new AllFilesController(globalService);
			return this.singleInstance;
		}else{
			return this.singleInstance;
		}
	}

    public setEnvObjects(globalService){
      this.globalService= globalService
      this.universalService=globalService.getUniversalServiceRef();
      this.router = globalService.getRouterRef();
      this.http = globalService.getHttpClientRef(); 
      this.listService = globalService.getListServiceRef();
      this.loggerService = globalService.getLoggerServiceRef();
      this.localStorageSvc = this.globalService.getLocalStorageSvcRef();
      this.sessionStorageService = this.globalService.getSessionStorageSvcRef();
      this.containerHeightCalc = globalService.getContainerHeightCalculatorService();
      this.lazyLoadImgService = globalService.getLazyLoadImgServiceRef();
      this.sessionStorageService = globalService.getSessionStorageSvcRef();
      if(this.universalService.virtualGridEnabled){
        this.lazyLoadImgService = globalService.getVirtualLazyLoadImgServiceRef();
      }
    }

    getFetchAllFilesFoldersUrl(type?:string){
      let url:string = "";
      let limit:number  = type=='w' && !this.universalService.listView && !this.universalService.virtualGridEnabled  ? 1000 : ENV_CONFIG["constants"]["PAGE_LIMIT"];

      limit = limit == ENV_CONFIG["constants"]["PAGE_LIMIT"] ? limit * ENV_CONFIG["constants"]["PAGINATION_BUFFER"] : limit
      if (this.universalService.sharingAlbumFiles) {
        url = ENV_CONFIG.commonUrls["shareURL"] + this.localStorageSvc.getLocalProperty(LocalStorageProps.SHARE_KEY,true) + "?";
        this.allFilesImplementation.rootFolderCheck = false;
      }
      else {
        const currentFolderKey = this.sessionStorageService.getCurrentFolderkey(true);
        const rootFolderKey = USER_DETAILS["USER_DETAILS"]["rootFolderKey"];
        const privateFolderKey = this.localStorageSvc.getPrivateFolderKey();
        const currentPrivateFolderKey = this.sessionStorageService.getCurrentPrivateFolderKey(true) == false? "":this.sessionStorageService.getCurrentPrivateFolderKey(true);

        if(this.universalService.currentTab == "PrivateFolder"){
          this.listService.getPPFToken();
          url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["nms"] + ENV_CONFIG.commonUrls["metaData"]  + "/ppf?limit="+ limit  + "&folderKey=";
          this.universalService.openFolderContent = currentPrivateFolderKey && currentPrivateFolderKey != privateFolderKey? true: false;
          if( currentPrivateFolderKey!="" && currentPrivateFolderKey!=privateFolderKey ){
            url = url+ currentPrivateFolderKey
            this.allFilesImplementation.rootFolderCheck = false;
          }else {
            url = type ?  url + privateFolderKey + "&type=" + type : url + privateFolderKey;
            this.allFilesImplementation.rootFolderCheck = true;
          } 
        }else{
          this.universalService.openFolderContent = currentFolderKey && currentFolderKey !=rootFolderKey? true: false;
          // if(this.universalService.listView) {
          //   url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["nms"] + ENV_CONFIG.commonUrls["metaData"]  + "?limit="+ limit  + "&folderKey=";
          // } else {
          //   url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["nms"] + ENV_CONFIG.commonUrls["metaData"] + ENV_CONFIG.commonUrls["nmsMetadataDefaultviewMyfiles"] + "?limit="+ limit  + "&folderKey=";
          // }
          if(this.universalService.openFolderContent) {//For inside a folder call old NMS
            url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["nms"] + ENV_CONFIG.commonUrls["metaData"]  + "?limit="+ limit  + "&folderKey=";
            if (currentFolderKey) {
              url = url+ currentFolderKey;
              this.allFilesImplementation.rootFolderCheck = false;
            }
          } else { // New NMS call
            url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["nms"] + ENV_CONFIG.commonUrls["metaData"] + ENV_CONFIG.commonUrls["nmsMetadataDefaultviewMyfiles"] + "?limit="+ limit  + "&folderKey=";
            if (currentFolderKey) {
              url = type ?  url + currentFolderKey + "&type=" + type : url + currentFolderKey;
              this.allFilesImplementation.rootFolderCheck = false;
            } else {
              url = type ?  url + USER_DETAILS["USER_DETAILS"]["rootFolderKey"] + "&type=" + type : url + USER_DETAILS["USER_DETAILS"]["rootFolderKey"];
              this.allFilesImplementation.rootFolderCheck = true;
            }
          }
        }
      }
      this.allFilesImplementation.setHandler(this.globalService);
      return url;
    }

    getAllFiles(type?:string,showMoreFolders?:boolean) {
      const url:string = this.getFetchAllFilesFoldersUrl(type);
      try {
        this.allFilesImplementation.getAllFilesAndFoldersData(url)
      } catch (exc) {
        this.loggerService.log("exception in all files api");
      }
    }
  
    async getAllFilesAndFolders(){
      let self = this;
      const currentFolderKey = this.sessionStorageService.getCurrentFolderkey(true);
      const rootFolderKey = USER_DETAILS["USER_DETAILS"]["rootFolderKey"];// this.localStorageSvc.getRootFolderKey();
      const currentPrivateFolderKey = self.sessionStorageService.getCurrentPrivateFolderKey(true);
      const pfKey = self.localStorageSvc.getPrivateFolderKey();
      self.allFilesImplementation.refetchData = true;
      if(self.universalService.currentTab == "allfiles"  && (currentFolderKey && currentFolderKey!= rootFolderKey)) {
        if((self.universalService.listView && !self.universalService.isMobileDevice) || (currentFolderKey && currentFolderKey!= rootFolderKey)
          || this.universalService.virtualGridEnabled){
           await self.getAllFiles();
          } else {
            await self.fetchFolder();
            await self.fetchFiles()
          }
      } else{
        if((self.universalService.currentTab == "allfiles" && ((self.universalService.listView && !self.universalService.isMobileDevice) || this.universalService.virtualGridEnabled))) {
          if(self.universalService.listView){
            this.universalService.sortByDateArray = [];
            this.universalService.sortByNameArray = [];
            this.universalService.foldersArray = [];
          }
          await self.fetchFolder(); // first fetch folders in case of new api
        } else if((self.universalService.listView && !self.universalService.isMobileDevice) 
          || (self.universalService.currentTab == "PrivateFolder" && pfKey != currentPrivateFolderKey) || this.universalService.virtualGridEnabled){
            if(self.universalService.listView){
              this.universalService.sortByDateArray = [];
              this.universalService.sortByNameArray = [];
              this.universalService.foldersArray = [];
            }
          await self.getAllFiles();
        } else {
          await self.fetchFolder();
          await self.fetchFiles();
        }
      }
    }


    fetchFolder(showAllFolder:boolean= false){
      this.getAllFiles('w', showAllFolder);
    }

    fetchFiles(){
      this.getAllFiles('f');
    }

    onScrollDown(docheignt, toppos,containerName) {
      let self = this;
      if(!this.universalService.virtualGridEnabled){
        self.lazyLoadImgService.isScrollingStopped();
      }

      if(self.universalService.listView && !self.universalService.isMobileDevice){
        return
      }
      self.allFilesImplementation.allFilesnextLink  = self.universalService.allFilesnextLink
      var url = "";
      url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + self.allFilesImplementation.allFilesnextLink;
      try {
        self.allFilesImplementation.createUrlForNextLink(docheignt, toppos, url,containerName);
      }
      catch (exc) {
        self.loggerService.log("exception in scroll down")
      }
    }
  
  
    openFolder(folder, moduleMetadataObj?) {
      var collapsedHeight = $('#m-collapsed-modal .modal-content').height();
      collapsedHeight = collapsedHeight?collapsedHeight:0
      const result = this.allFilesImplementation.openFolder(folder, moduleMetadataObj);
    }
  
    openPublicSort(sortType,reverseOrder) {
      this.universalService.disableModalBackdrop();
      let sortTypeName = this.universalService.togglePublicSort(sortType,reverseOrder);
      if(sortTypeName!=""){
          this.sessionStorageService.setSharePublicSortPropName(sortTypeName);
      }
      this.allFilesImplementation.allFilespreviousLink = "";
      this.universalService.isMobileTopMoreOptionMenu = false;
      this.universalService.sharePublicSortByUploadDate = "";
      this.switchView();
    }


    switchView(){
      this.universalService.sortByDateArray = [];
      this.universalService.sortByNameArray = [];
      this.universalService.foldersArray = [];
      this.getAllFilesAndFolders();
    }
  
  
    onListScrollDown() { // this will get called when user is inside folder in list view only
      this.allFilesImplementation.allFilesnextLink  = this.universalService.allFilesnextLink
      var url = "";
      url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + this.allFilesImplementation.allFilesnextLink;
      try {
        this.allFilesImplementation.createUrlForNextLinkOnDesktop(url);
      }
      catch (exc) {
        this.loggerService.log("exception in scroll down")
      }
    }

    decideScrollCall(){ // this will get called when user is inside folder in list view only
      // if(this.universalService.openFolderContent){
        if(this.listService.listOptions.api.getDisplayedRowCount() == 0) return
        this.onListScrollDown();
      // }
    }

    async updateUIAfterPerformingAction(list,executedTask){
      var array = []
      if(this.universalService.nameSort){
        array = this.universalService.sortByNameArray
      }else{
        array = this.universalService.sortByDateArray
      }
      if(executedTask == 'TRASH' || executedTask == "MOVE"){
        this.fileOperationsImplementation.setHandler(this.globalService);
        if( this.universalService.currentTab == 'allfiles' || executedTask == 'TRASH'){
          var result = await this.fileOperationsImplementation.updateSummaryCountsAndUI(array,list,executedTask);
          array = result
        }
        if(this.universalService.virtualGridEnabled){
          AppEvents.virtualDOMObservable.next({"updateVDOM":true,"removeObjects":true,objectsList:list})
        }
      }else if(executedTask == 'RENAME' || executedTask == 'SETFAV' || executedTask == 'UNSETFAV' || executedTask == "SHAREPERMISSION"){
          this.fileOperationsImplementation.setHandler(this.globalService);
          var result = await this.fileOperationsImplementation.updateOnlyTheUI(array, list,executedTask)
          array = result
          if(this.universalService.virtualGridEnabled){
            let updatedList = this.fileOperationsImplementation.returnTheListOfUpdatedObjectsForVirtualGrid(list,array);
            AppEvents.virtualDOMObservable.next({"updateVDOM":true,"updateObjects":true,objectsList:updatedList})
          }
      }else{
          this.loggerService.log("task invalid",executedTask)
      }
      if(array.length == 0){
        return "empty"
      }else{
        return ""
      }
  }

  selectAll(event){
    this.allFilesImplementation.selectAll(event)
  }

  async getNextPageData(){
    this.getAllFilesAndFolders()
    // if(this.allFilesImplementation.allFilesnextLink){
    //   var url = "";
    //   url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + this.allFilesImplementation.allFilesnextLink;
    //   try {
    //     this.listService.disableSelectionModeInListView = true;
    //     var result = await this.allFilesImplementation.getNextPageData(url);
    //     if(result["resp"]["objects"].length == 0){
    //       this.universalService.showLoader = true;
    //       this.getAllFilesAndFolders();
    //     }
        
    //   }
    //   catch (exc) {
    //     this.loggerService.log("exception in scroll down")
    //   }
    // }else if(this.universalService.openFolderContent && (this.universalService.foldersArray.length == 0 || (this.universalService.listView && this.listService.listOptions.api.getDisplayedRowCount() == 0) )){
    //   this.universalService.emptyFolder = true;
    // }else if(!this.universalService.openFolderContent && (this.universalService.foldersArray.length == 0 || (this.universalService.listView && this.listService.listOptions.api.getDisplayedRowCount() == 0) )){
    //     this.universalService.emptyTab = true;
    // }
    
  }

  async getObjectMetadata(objectKey){
    var metadataURL = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["nmsMetaData"] + "/" + objectKey + "/info";
    try{
      var result
      result = await this.allFilesImplementation.getObjectMetadata(metadataURL);
      if(result){
        return result;
      }
    }catch(err){
      console.log("error in metadata",err);
      return null
    }
  }
}